module.exports = __webpack_public_path__ + "assets/img/bg@3x.ccf70b1f.png";